import { JsonResources, JsonResourcesSetting } from "./common/JsonResources";
import { LocalStorageClass } from "./common/LocalStorage";
import { ImageNumber } from './common/ImageNumber';
import { TextLoader } from './common/TextLoader';

export class GameQuizResources extends JsonResources {
    constructor(){
        super();
    }


    /**
     *
     * @param setting
        */
    async loadManifest() {
        await this.load(this.settings);
    }

    
    getImage(s:string): createjs.Sprite { return new createjs.Sprite(this.ss[s]) };

    get_background(): createjs.Sprite { return new createjs.Sprite(this.ss["background"]) };
    get_background_p(): createjs.Sprite { return new createjs.Sprite(this.ss["background_p"]) };
    get_background_m(): createjs.Sprite { return new createjs.Sprite(this.ss["background_m"]) };
    get_title_title(): createjs.Sprite { return new createjs.Sprite(this.ss["title_main"]) };

    get_banner1(): createjs.Sprite { return new createjs.Sprite(this.ss["banner1"]) };
    get_banner2(): createjs.Sprite { return new createjs.Sprite(this.ss["banner2"]) };
    get_banner3(): createjs.Sprite { return new createjs.Sprite(this.ss["banner3"]) };

    get_title_btn_start_a(): createjs.Sprite { return new createjs.Sprite(this.ss["game"], "btn_start_one") };
    get_title_btn_start_b(): createjs.Sprite { return new createjs.Sprite(this.ss["game"], "btn_start_two") };
    
    get_game_window_answer(): createjs.Sprite { return new createjs.Sprite(this.ss["game"], "game_window_answer") };
    get_game_window_question(): createjs.Sprite { return new createjs.Sprite(this.ss["game"], "game_window_question") };
    get_game_window_selection(): createjs.Sprite { return new createjs.Sprite(this.ss["game"], "selection_bg") };
    get_game_timebar_bg(): createjs.Sprite { return new createjs.Sprite(this.ss["game"], "game_timegauge_bg") };
    get_game_timebar(): createjs.Sprite { return new createjs.Sprite(this.ss["game"], "game_timegauge_bar") };

    get_game_quiz_right(): createjs.Sprite { return new createjs.Sprite(this.ss["game"], "quiz_right") };
    get_game_quiz_wrong(): createjs.Sprite { return new createjs.Sprite(this.ss["game"], "quiz_wrong") };

    get_game_window_answer_a(): createjs.Sprite { return new createjs.Sprite(this.ss["game"], "game_window_answer_a") };
    get_game_window_answer_b(): createjs.Sprite { return new createjs.Sprite(this.ss["game"], "game_window_answer_b") };
    get_game_window_answer_c(): createjs.Sprite { return new createjs.Sprite(this.ss["game"], "game_window_answer_c") };
    get_game_window_answer_d(): createjs.Sprite { return new createjs.Sprite(this.ss["game"], "game_window_answer_d") };
    
    get_game_questionPyaker_once(): createjs.Sprite { return new createjs.Sprite(this.ss["game"], "ones") };
    get_game_questionPyaker_papa(): createjs.Sprite { return new createjs.Sprite(this.ss["game"], "papa") };
    get_game_questionPyaker_mama(): createjs.Sprite { return new createjs.Sprite(this.ss["game"], "mama") };

    get_game_result_ball_ok(): createjs.Sprite { return new createjs.Sprite(this.ss["game"], "score_smile") };
    get_game_result_ball_ng(): createjs.Sprite { return new createjs.Sprite(this.ss["game"], "score_cry") };

    get_game_result_btn_return(): createjs.Sprite { return new createjs.Sprite(this.ss["game"], "btn_return") };
    get_game_result_btn_retry(): createjs.Sprite { return new createjs.Sprite(this.ss["game"], "btn_retry") };
    
    //get_game_coupon_window(): createjs.Sprite { return new createjs.Sprite(this.ss["game"], "result_window") };
    
    get_game_countdown3(): createjs.Sprite { return new createjs.Sprite(this.ss["game"], "countdown3") };
    get_game_countdown2(): createjs.Sprite { return new createjs.Sprite(this.ss["game"], "countdown2") };
    get_game_countdown1(): createjs.Sprite { return new createjs.Sprite(this.ss["game"], "countdown1") };
    get_game_time_start(): createjs.Sprite { return new createjs.Sprite(this.ss["game"], "time_start") };
    
    

    get_game_timebar_bg_bmp(): createjs.Bitmap {
        var bmp = new createjs.Bitmap( this.settings[0].srcImage );
        bmp.sourceRect = this.get_game_timebar_bg_rect(1, 1);
        return bmp;
    }
    get_game_timebar_bg_rect(sw, sh) {
        var frame = this.get_game_timebar_bg();
        
        return new createjs.Rectangle(
            frame.spriteSheet.getFrame(0).rect.x,
            frame.spriteSheet.getFrame(0).rect.y,
            frame.spriteSheet.getFrame(0).rect.width * sw,
            frame.spriteSheet.getFrame(0).rect.height * sh,
        );
    }
    
    /*
    // スプライトシートの画像に対するトリミングがうまくいかないので画像単独で切り出し
    get_catchgame_system_time_normal_bmp(): createjs.Bitmap {
        var bmp = new createjs.Bitmap( this.settings[5].srcImage );
        bmp.sourceRect = this.get_catchgame_system_time_normal_rect(1, 1);
        return bmp;
    }
    get_catchgame_system_time_normal_rect(sw, sh) {
        var frame = this.get_catchgame_system_time_normal();
        return new createjs.Rectangle(
            frame.spriteSheet.getFrame(11).rect.x,
            frame.spriteSheet.getFrame(11).rect.y,
            frame.spriteSheet.getFrame(11).rect.width * sw,
            frame.spriteSheet.getFrame(11).rect.height * sh,
        );
    }
    get_catchgame_system_time_challenge_bmp(): createjs.Bitmap {
        var bmp = new createjs.Bitmap( this.settings[5].srcImage );
        bmp.sourceRect = this.get_catchgame_system_time_challenge_rect(1, 1);
        return bmp;
    }
    get_catchgame_system_time_challenge_rect(sw, sh) {
        var frame = this.get_catchgame_system_time_challenge();
        return new createjs.Rectangle(
            frame.spriteSheet.getFrame(10).rect.x,
            frame.spriteSheet.getFrame(10).rect.y,
            frame.spriteSheet.getFrame(10).rect.width * sw,
            frame.spriteSheet.getFrame(10).rect.height * sh,
        );
    }
    */

    // 数字データの初期化
    set_imagenumber () {
        var s = new ImageNumber("./asset/figure_score.png", 24, 35, {default:0, align:"right", max:999999});
        return s;
    }
    // 画像読み込みのため１回実行しておく
    temp = this.set_imagenumber();

    // 数字データの初期化
    set_imagenumber_result () {
        var s = new ImageNumber("./asset/figure_result.png", 28, 40, {default:0, align:"right", max:999999});
        return s;
    }
    // 画像読み込みのため１回実行しておく
    //temp = this.set_imagenumber_result();

    set_imageNumberText () {
        var param = {
            images: ["./asset/figure_score.png"],
            frames: 
                {width: 24, height: 35, regX:0, regY:0},
            animations: { "num": 0, "plus": 1 }
        }
        return new createjs.Sprite( new createjs.SpriteSheet(param) );
    }

    // 外付けファイルリスト
    public SingleImageList = [
        {
            id: "background",
            srcImage: "asset/images/background.png"
        },
        {
            id: "background_m",
            srcImage: "asset/images/background_m.png"
        },
        {
            id: "background_p",
            srcImage: "asset/images/background_p.png"
        },
        {
            id: "title_main",
            srcImage: "asset/images/title.png"
        },
        {
            id: "banner1",
            srcImage: "asset/images/koukoku_01.png"
        },
        {
            id: "banner2",
            srcImage: "asset/images/koukoku_02.png"
        },
        {
            id: "banner3",
            srcImage: "asset/images/koukoku_03.png"
        }
    ];

    //
    public QuestionLIst = {};

    //
    public async LoadingText() {
        
        const query = "?v=1";

        // シナリオスクリプト
        const ScriptFile = {
            "00":"asset/question.txt" + query
        }

        this.QuestionLIst = {};

        for(let j=0; j<Object.keys(ScriptFile).length; j++) {
            
            let keys = Object.keys(ScriptFile)[j]
            const scenariotextLoader = new TextLoader();
            scenariotextLoader.setURL( ScriptFile[ keys ] );
            scenariotextLoader.setUseCookie(false);
            const InitialData = await scenariotextLoader.load();

            this.QuestionLIst[ keys ] = [];

            const liness = InitialData.split("\r\n");
                liness.forEach((line, i) => {
                    //if (!line) return;
                    let splits = line.split(",");
                    this.QuestionLIst[ keys ][i] = splits;
                }
            );  
        };
    }

        // 
    // 音関係
    //
    public soundfile = [
        //{ id: "ADV_BGM_1", src: "asset/sound/トップBGM.mp3" },
        { id: "SE_QUIZ_OPNE", src: "asset/sound/クイズ出題2.mp3" },
        { id: "SE_QUIZ_OK", src: "asset/sound/クイズ正解5.mp3" },
        { id: "SE_QUIZ_NG", src: "asset/sound/クイズ不正解1.mp3" },
        { id: "SE_START_COUNT", src: "asset/sound/パッ.mp3" },
        { id: "SE_START_DOWN", src: "asset/sound/ジャン！.mp3" },
        { id: "SE_RESULT_COUNT", src: "asset/sound/ペタッ.mp3" },
        { id: "SE_RESULT_DOWN", src: "asset/sound/ジャジャーン.mp3" },
        { id: "SE_QUIZ_TIMER", src: "asset/sound/制限時間タイマー.mp3" },
    ];

    check_soundloading() {

        let bool = true;
        let cnt = 0;
        let ret = {"cnt":0, "flg":false}

        for(let i=0; i<this.soundfile.length; i++) {
            //console.log(this.soundfile[i]);
            //console.log(  ) ) ;

            if (!createjs.Sound.loadComplete( this.soundfile[i].src) ) {
                bool = false;
                break;
            } else {
                ret.cnt++;
            }
        }

        if (ret.cnt >= this.soundfile.length) ret.flg = true;

        return ret;
    }
   
}
